var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSouthArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 18.75L21.9875 16.9875L16.25 22.7125V2.5H13.75V22.7125L8.0125 16.975L6.25 18.75L15 27.5L23.75 18.75Z",
    fill: "#BA5E98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthArrow);
export default __webpack_public_path__ + "static/media/south-arrow.6fbb624102276ab43feab1947d618914.svg";
export { ForwardRef as ReactComponent };